import React, { JSX } from "react";
import { useMultiLang } from "helpers/multiLang";

type ItemProps = {
  label: string;
};

export const Item = ({ label }: ItemProps): JSX.Element => {
  return (
    <div className="inline-block px-2 mb-1 mr-2 leading-5 text-xs text-blue-500 bg-blue-500 bg-opacity-5">
      {label}
    </div>
  );
};

type ItemListProps = {
  keyString: string;
  items: Array<any>;
};

export const ItemList = ({
  keyString,
  items,
}: ItemListProps): JSX.Element[] | null => {
  const m = useMultiLang();

  return items?.map((item: any) => (
    <Item key={item?.id} label={m(item[keyString]?.name) ?? item?.newText} />
  ));
};

type ItemListPlainProps = {
  items: string[];
  className?: string;
};

export const ItemListPlain = ({
  items,
  className,
}: ItemListPlainProps): JSX.Element => {
  return (
    <div className={className}>
      {items?.map((item: any) => (
        <Item key={item} label={item} />
      ))}
    </div>
  );
};
